import React, { Component } from 'react'
import './tracknumber.css'
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import orange from '@material-ui/core/colors/orange'


class TrackNumber extends Component {
  state = {
    value: '',
    isEdit: true,
    isComplete: false
  }

  componentDidMount() {
    this.setState({
      value: this.props.number
    })
  }

  onChange = (event) => {
    const value = event.target.value;

    this.setState({
      value: value
    })

  }

  handleActionEdit = () => {
    this.setState({
      isComplete: true,
      isEdit: false,
    })
  }
  handleActionComplete = () => {
    this.setState({
      isComplete: false,
      isEdit: true,
    })
    const field = this.props.field
    const jData = {
      [field]: this.state.value
    }

    this.props.onSubmit(this.props.id, jData)
  }

  renderButton = () => {
    const { classes } = this.props
    if (!this.props.access.edit) {
      return null
    }
    // orange
    if (this.state.isEdit) {
      return (
        <IconButton onClick={this.handleActionEdit} className={classes.edit}>
          <Icon>edit</Icon>
        </IconButton>
      )
    }
    // blue
    if (this.state.isComplete) {
      return (
        <IconButton onClick={this.handleActionComplete} color={"primary"}>
          <Icon>save</Icon>
        </IconButton>)
    }
  }

  render() {

    return (
      <div className="ticket__info-group_item" style={{
        alignItems: 'center',
        position: 'relative'
      }}>
        <span>{this.props.title}:</span>
        <FormControl className="input-field inline" >
          <Input disabled={(this.state.isEdit) ? true : false}
            value={this.state.value}
            onChange={this.onChange}
            type="text"
            maxLength='14'
            style={{ width: '60%', fontSize: '1.3rem' }}
            endAdornment={this.renderButton()}
          />
        </FormControl>
      </div>
    )
  }
}

const styles = theme => ({
  edit: {
    color: orange[500]
  }
})


export default withStyles(styles)(TrackNumber);


// WEBPACK FOOTER //
// ./src/components/TrackNumber/TrackNumber.js